import { AxiosRequestConfig } from "axios";

import { ITopicResource } from "../../topics";
import { createApiQueryHook } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ITopic } from "../types";

export type ITopicQueryParameters = {
    topic?: RelationalValue<ITopicResource>;
};

export type ITopicQueryResult = ITopic;

export function topicQuery({ topic }: ITopicQueryParameters): AxiosRequestConfig | undefined {
    if (!topic) {
        return;
    }

    return { method: "GET", url: `/topics/${mapRelationalValue(topic)}` };
}

export const useTopicQuery = createApiQueryHook<ITopicQueryParameters, ITopicQueryResult>(topicQuery);
